"use client";

import { useId } from "react";

// =============================================================================

// 8-petal flower whose upper-right and lower-left petals hide behind the bar
const PETAL_ANGLES = [-90, -135, 180, 90, 45, 0];
const GAP_ANGLES = [-112.5, -157.5, 22.5, 67.5, 157.5, -67.5, -22.5, 112.5];

/** Rounded: Node and the browser disagree on the last digits of cos/sin,
    which breaks the hydration of the server rendered icon */
function polar(angle: number, radius: number): [number, number] {
  const rad = (angle * Math.PI) / 180;
  const round = (value: number) => Math.round(value * 1000) / 1000;
  return [
    round(12 + radius * Math.cos(rad)),
    round(12 + radius * Math.sin(rad)),
  ];
}

type MaltIconProps = {
  className?: string;
  a11y: { role?: "img"; "aria-label"?: string; "aria-hidden"?: boolean };
};

/**
 * Malt symbol (simple-icons only ships the wordmark).
 */
export function MaltIcon({ className, a11y }: MaltIconProps) {
  const maskId = `malt-${useId().replace(/:/g, "")}`;

  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      className={className}
      {...a11y}
    >
      <defs>
        <mask id={maskId}>
          <rect width="24" height="24" fill="#fff" />
          {GAP_ANGLES.map((angle) => {
            const [x, y] = polar(angle, 13);
            return (
              <line
                key={angle}
                x1="12"
                y1="12"
                x2={x}
                y2={y}
                stroke="#000"
                strokeWidth="1.05"
              />
            );
          })}
          <rect
            x="7.95"
            y="-1"
            width="8.1"
            height="26"
            rx="4.05"
            transform="rotate(42 12 12)"
            fill="#000"
          />
        </mask>
      </defs>
      <g mask={`url(#${maskId})`}>
        {PETAL_ANGLES.map((angle) => {
          const [cx, cy] = polar(angle, 6.3);
          return (
            <ellipse
              key={angle}
              cx={cx}
              cy={cy}
              rx="4.6"
              ry="3.3"
              transform={`rotate(${angle} ${cx} ${cy})`}
            />
          );
        })}
      </g>
      <rect
        x="9.35"
        y="1"
        width="5.3"
        height="22"
        rx="2.65"
        transform="rotate(42 12 12)"
      />
    </svg>
  );
}

// =============================================================================
